module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-8-d1a5999f40a260570ad07138cf05018c.jpg";